import request from "@/utils/request"

// 新增商家产品模板
export function addTemplate(data) {
  return request({
    url: "/server/universal/template/add",
    method: "post",
    data: data,
  })
}

// 查询商家产品模板列表
export function getTemplateList(data) {
  return request({
    url: "/server/universal/template/list",
    method: "get",
    params: data,
  })
}

// 删除商家产品模板
export function delTemplate(data) {
  return request({
    url: "/server/universal/template/delete/" + data,
    method: "post",
  })
}

// 获取商家产品模板详细信息 用于查看详情
export function getTemplateInfo(data) {
  return request({
    url: "/server/universal/template/getInfo/" + data,
    method: "get",
  })
}

export function getVarList(data) {
  return request({
    url: "/server/var/list",
    method: "get",
    params: data,
  })
}

// 查询默认属性列表
export function listDefault(data) {
  return request({
    url: "/server/universal/template/listDefault",
    method: "get",
    params: data,
  })
}
// 查询默认属性列表
export function addRemit(data) {
  return request({
    url: "/server/universal/template/addRemit",
    method: "post",
    data: data,
  })
}
// 查询汇出Amazon列表
export function getRemitList(params) {
  return request({
    url: "/server/universal/template/listRemit",
    method: "get",
    params: params,
  })
}

export function getVarListDesign(data) {
  return request({
    url: "/server/var/listDesign",
    method: "get",
    params: data,
  })
}

export function cancelTiming(data) {
  return request({
    url: "/server/universal/template/cancelTiming",
    method: "post",
    data: data,
  })
}
